import { DEFAULT_DEV_BRAND_CODE, isDevelopment } from "appConfiguration";
import { BrandCode } from "core/entities";

const DomainMap = new Map<string, BrandCode>([
  ["procolor", "proc"],
  ["fixauto", "fixaut"],
  ["novusglass", "novusglass"],
  ["speedyauto", "speedyauto"],
  ["speedy", "speedyauto"],
  ["speedyglass", "speedyglass"],
  ["collisionrepairexperts", "cre"],
  ["collisionrepairexperts", "cre"],
  ["novuscrystalglass", "crystalglass"],
]);

if (isDevelopment) {
  DomainMap.set("localhost", DEFAULT_DEV_BRAND_CODE);
}

export default DomainMap;
